module.exports = __webpack_public_path__ + "img/BETPANDA.b5467d78.svg";